import MarkdownIt from 'markdown-it';
import React from 'react';
import { FiInfo } from 'react-icons/fi';
import MdEditor, { Plugins } from 'react-markdown-editor-lite';
import 'react-markdown-editor-lite/lib/index.css';
import { DashboardHeader } from '../../core/DashboardHeader';
import { DashboardWrapper } from '../../core/DashboardWrapper';
import { FeatureImageCard } from '../../core/reusable-forms/FeatureImageCard';
import { RhButton, RhButtonMode } from '../../core/RhButton';
import { RhCard } from '../../core/RhCard';
import { H4 } from '../../core/Styles';
import { ChurchFormProps } from '../church-form.helper';
import { RhInput, RhInputMode } from '../../core/RhInput';
export const ChurchFormScreen = (props: ChurchFormProps) => {
  return (
    <DashboardWrapper>
      <DashboardHeader
        title={props.mode == 'add' ? 'New Church' : 'Edit Church'}
        actions={[
          <RhButton
            disabled={props.isLoading}
            loading={props.isLoading}
            key="cancel"
            mode={RhButtonMode.hollow}
            title="Cancel"
            onClick={props.userClickedCancel}
          />,
          <RhButton
            disabled={props.isLoading}
            loading={props.isLoading}
            key="save"
            title="Save Section"
            onClick={props.userClickedSaveSection}
          />,
        ]}
      />
      <div className="grid grid-cols-6 gap-5">
        {/* 1st column */}
        <div className="col-span-4">
          <RhCard>
            <RhInput
              disabled={props.isLoading}
              mode={RhInputMode.subtle}
              placeholder="Name"
              value={props.formState.name}
              onChange={e =>
                props.userUpdatedFormState({
                  ...props.formState,
                  name: e.target.value,
                })
              }></RhInput>
            <br />
            <RhInput
              disabled={props.isLoading}
              mode={RhInputMode.subtle}
              placeholder="Address"
              containerStyle={{ width: '100%' }}
              value={props.formState.address}
              onChange={e =>
                props.userUpdatedFormState({
                  ...props.formState,
                  address: e.target.value,
                })
              }></RhInput>
            <br />
            <RhInput
              disabled={props.isLoading}
              mode={RhInputMode.subtle}
              placeholder="Phone"
              containerStyle={{ width: '100%' }}
              value={props.formState.phone}
              onChange={e =>
                props.userUpdatedFormState({
                  ...props.formState,
                  phone: e.target.value,
                })
              }></RhInput>
          </RhCard>
        </div>
      </div>
    </DashboardWrapper>
  );
};
